import React from 'react';
import {
  Tooltip,
  Box,
  Flex,
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Divider,
  VStack,
  HStack,
  CircularProgress,
  CircularProgressLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Grid,
  IconButton,
  Spinner,
  Image,
  useBreakpointValue,
  Progress,
  useToast,
  useDisclosure,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useColorModeValue,
} from '@chakra-ui/react';
import { keyframes } from '@chakra-ui/system';
import { RepeatIcon, SearchIcon } from '@chakra-ui/icons';
import moment from 'moment-timezone';
import axiosInstance from 'axiosInstance';
import baseUrl from 'Base_Url/baseUrl';
import mqtt from 'mqtt';
import { useEffect, useState, useRef, useCallback } from 'react';
import { ReactComponent as BorewellIconPumpOn } from '../../../assets/icons/Borewell_Icon_Pump_On.svg';
import { ReactComponent as BorewellIconPumpOff } from '../../../assets/icons/Borewell_Icon_Pump_Off.svg';
import { ReactComponent as WaterLimitIcon } from '../../../assets/icons/Water Limit Icon.svg';
import { ReactComponent as TankLevelIcon } from '../../../assets/icons/Tank Icon.svg';
import BorewellImage from '../../../assets/icons/Borewell Image1.png';
import { ReactComponent as DisconnectedIcon } from '../../../assets/icons/Disconnected device.svg';
import { ReactComponent as ConnectedIcon } from '../../../assets/icons/Connected device.svg';
import { ReactComponent as RemoteButtonOn } from '../../../assets/icons/Remote operation.svg';
import { ReactComponent as RemoteButtonOff } from '../../../assets/icons/Remote_operation_off.svg';
import PumpProcessing from '../../../assets/icons/mqtt_pump_processing.gif';
import OnIcon from '../../../assets/icons/On icon.svg';
import OffIcon from '../../../assets/icons/Off icon.svg';
import Overview from '../profile';
import { MdNewReleases } from 'react-icons/md';
import { setISODay } from 'date-fns';
import { useUser } from '../../../userContext';
import { notifyApiError } from 'utils/apiFeedback';

export default function Dashboard() {
  const gridCols = useBreakpointValue({ base: 1, md: 2, lg: 3 });
  const [overViewData, setOverViewData] = useState([]);
  const [deviceSearch, setDeviceSearch] = useState('');
  const [tankOverViewData, setTankOverViewData] = useState([]);
  const [isTankModalOpen, setisTankModalOpen] = useState(false);
  const [companyData, setCompanyData] = useState([]);
  const [limitPerDay, setLimitPerDay] = useState();
  const [limitPerYear, setlimitPerYear] = useState();
  const [WaterTankLevel, setWaterTankLevel] = useState(0);
  const [plantDailyCons, setPlantDailyCons] = useState(0);
  const [plantYearlyCons, setPlantYearlyCons] = useState(0);
  const [pendingPacket, setPendingPacket] = useState(null);
  const [pendingTopic, setPendingTopic] = useState(null);
  const [isProcessing, setProcessing] = useState(false);

  const { updateLicenseData } = useUser();

  const dailyProgressValue = (plantDailyCons / limitPerDay) * 100;
  const yearlyProgressValue = (plantYearlyCons / limitPerYear) * 100;

  const selectedCompany = useRef('');
  const ACK_TIMEOUT = 15;
  const publishingRef = useRef(false);
  const ackReceivedRef = useRef(false);
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);
  const clientRef = useRef(null);
  const cancelRef = useRef();
  const pendingPIDRef = useRef(null);
  const stateLastSeenRef = useRef({});
  const stateStatusTimeoutsRef = useRef({});
  const [loading, setLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedPID, setSelectedPID] = useState('');
  const STATE_STATUS_TIMEOUT_MS = 2 * 60 * 1000;
  const messageHandlerRef = useRef(null); // ✅ Store handler reference

  const toast = useToast();
  const Token = localStorage.getItem('token');
  const userRole = localStorage.getItem('role');
  const pageBg = useColorModeValue('gray.50', 'dark.900');
  const surfaceBg = useColorModeValue('white', 'dark.800');
  const subtleSurfaceBg = useColorModeValue(
    'rgba(248, 251, 255, 1)',
    'dark.700',
  );
  const softBorderColor = useColorModeValue(
    'rgba(196, 215, 232, 1)',
    'dark.600',
  );
  const panelBorderColor = useColorModeValue('blackAlpha.50', 'dark.600');
  const textPrimary = useColorModeValue('gray.800', 'gray.100');
  const textMuted = useColorModeValue('gray.500', 'gray.400');
  const accentColor = useColorModeValue('rgba(0, 106, 184, 1)', 'aqua.300');
  const accentStrongColor = useColorModeValue(
    'rgba(17, 128, 211, 1)',
    'aqua.300',
  );
  const tableHeaderBg = useColorModeValue(
    'rgba(232, 244, 255, 1)',
    'dark.700',
  );
  const tableBorderColor = useColorModeValue(
    'rgba(0, 106, 184, 0.18)',
    'dark.600',
  );
  const progressTrackBg = useColorModeValue('gray.200', 'dark.700');
  const iconButtonBg = useColorModeValue('white', 'dark.800');
  const iconButtonHoverBg = useColorModeValue('gray.100', 'dark.700');
  const emptyStateBg = useColorModeValue('white', 'dark.800');
  const scrollTrackBg = useColorModeValue('#dce4ec', '#111827');
  const shadowValue = useColorModeValue('sm', '0 18px 48px rgba(0, 0, 0, 0.24)');
  const normalizedDeviceSearch = deviceSearch.trim().toLowerCase();
  const filteredOverviewData = normalizedDeviceSearch
    ? overViewData.filter((device) => {
        const searchableValues = [
          device?.borewellName,
          device?.productId,
          device?.status,
          device?.system?.pump_status,
          device?.system?.operation_mode,
          device?.system?.remote_operations,
        ];

        return searchableValues.some((value) =>
          String(value || '')
            .toLowerCase()
            .includes(normalizedDeviceSearch),
        );
      })
    : overViewData;

  // Local Broker
  // const brokerUrl = 'ws://localhost:8082';
  // const username = '';
  // const password = '';

  // Staging Broker
  // const brokerUrl = 'wss://atbcmqtt.aquasense.tech:9001';
  // const username = 'admin';
  // const password = 'fVAYl6k2Kd9Z';

  // Production Broker
  const brokerUrl = 'wss://atbc.aquasense.tech:9001';
  const username = 'atbcmqtt';
  const password = 'atbc@mqtt1911';

  // Define the blinking keyframes
  const blinkAnimation = keyframes`
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`;

  const blinkingOverlayProps = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    borderRadius: 'full',
    border: '8px solid white',
    animation: `${blinkAnimation} 1s infinite alternate`,
    boxSizing: 'border-box',
    pointerEvents: 'none',
    zIndex: '100',
  };

  const formatForDateTimeLocal = (isoString) => {
    if (!isoString) return '-';
    return moment(isoString).format('DD/MM/YY HH:mma');
  };

  const formatTankCapacity = (capacity) => {
    if (capacity === undefined || capacity === null || capacity === '') {
      return '-';
    }

    const capacityText = String(capacity).trim();
    return capacityText.toLowerCase().includes('kl')
      ? capacityText
      : `${capacityText} KL`;
  };

  const getReadingNumber = (value) => {
    if (value === undefined || value === null) return null;

    const readingText = String(value).trim();
    if (
      readingText === '' ||
      readingText === '-' ||
      readingText.toLowerCase() === 'nan'
    ) {
      return null;
    }

    const numericValue = Number(readingText);
    return Number.isFinite(numericValue) ? numericValue : null;
  };

  const formatReading = (value, { decimals = 1, unit = '' } = {}) => {
    const numericValue = getReadingNumber(value);

    return Number.isFinite(numericValue)
      ? `${numericValue.toFixed(decimals)}${unit}`
      : '-';
  };

  const generateMid = () =>
    Math.floor(100000000 + Math.random() * 900000000).toString();

  const confirmAndSend = (packet, topic) => {
    setPendingPacket(packet);
    setPendingTopic(topic);
    onOpen();
  };

  const toggleIsProcessing = () => {
    setProcessing(true);
    setTimeout(() => {
      setProcessing(false);
    }, 16000);
  };

  const tanksOverview = () => {
    const tankData = Object.values(
      overViewData.reduce((acc, device) => {
        const tank = device.tankMetaData;
        if (!tank) return acc;

        const tankId = tank._id;

        if (!acc[tankId]) {
          acc[tankId] = {
            _id: tank._id,
            name: tank.name,
            capacity: tank.capacity,
            connected_to: [],
            tank_water_level: device?.tank_sensor?.water_level ?? null,
            tank_water_temperature:
              device?.tank_sensor?.water_temperature ?? null,
          };
        }

        if (!acc[tankId].connected_to.includes(device.productId)) {
          acc[tankId].connected_to.push(device.productId);
        }

        return acc;
      }, {}),
    );
    setTankOverViewData(tankData);
  };

  const handlePumpToggle = (pump_status, productId) => {
    pendingPIDRef.current = productId;
    let cmdPacketPumpOperation = {};
    let pump_control = '';
    if (pump_status === 'on') {
      pump_control = 'off';
    } else {
      pump_control = 'on';
    }

    const timestamp = moment().tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss');
    const mid = generateMid();

    cmdPacketPumpOperation.pid = productId;
    cmdPacketPumpOperation.mid = mid;
    cmdPacketPumpOperation.timestamp = timestamp;
    cmdPacketPumpOperation.pump_control = pump_control;

    const jsonParsed = JSON.stringify(cmdPacketPumpOperation);
    confirmAndSend(jsonParsed, 'ATBC/C2D');
  };

  const handleRemoteToggle = (remote_operations, productId) => {
    pendingPIDRef.current = productId;
    let cmdPacketRemoteOperation = {};
    let remote_operation_status = '';
    if (remote_operations === 'on') {
      remote_operation_status = 'off';
    } else {
      remote_operation_status = 'on';
    }

    const timestamp = moment().tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss');
    const mid = generateMid();

    cmdPacketRemoteOperation.pid = productId;
    cmdPacketRemoteOperation.mid = mid;
    cmdPacketRemoteOperation.timestamp = timestamp;
    cmdPacketRemoteOperation.remote_operations = remote_operation_status;

    const jsonParsed = JSON.stringify(cmdPacketRemoteOperation);
    confirmAndSend(jsonParsed, 'ATBC/C2D');
  };

  const handleConfirm = () => {
    onClose();

    const packet = pendingPacket;
    const topic = pendingTopic;

    if ('pump_control' in JSON.parse(packet)) {
      toggleIsProcessing();
    }

    if (publishingRef.current) {
      toast({
        title: 'Please wait for the previous operation to complete',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (!clientRef.current) {
      console.error('MQTT client is not connected');
      return;
    }

    publishingRef.current = true;

    clientRef.current.publish(topic, packet, { qos: 2 }, (err) => {
      if (err) {
        publishingRef.current = false;
        toast({
          title: 'Failed to publish packet',
          status: 'error',
          duration: 3000,
        });
        return;
      }

      toast({
        title: 'Packet sent successfully!',
        status: 'success',
        duration: 2000,
      });

      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }

      toast.close('ack-countdown');
      ackReceivedRef.current = false;

      let countdown = ACK_TIMEOUT;

      toast({
        id: 'ack-countdown',
        title: `Waiting for device acknowledgment... ${countdown}s`,
        status: 'info',
        duration: null,
        isClosable: false,
      });

      intervalRef.current = setInterval(() => {
        countdown -= 1;

        if (countdown <= 0) return;

        try {
          toast.update('ack-countdown', {
            title: `Waiting for device acknowledgment... ${countdown}s`,
            status: 'info',
            duration: null,
            isClosable: false,
          });
        } catch (err) {
          console.warn('Toast update failed, clearing countdown:', err);
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      }, 1000);

      timeoutRef.current = setTimeout(() => {
        if (!ackReceivedRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;

          toast.close('ack-countdown');

          publishingRef.current = false;

          toast({
            title: 'Device did not respond, rolling back to previous state',
            status: 'error',
            duration: 4000,
            isClosable: true,
          });
        }
      }, ACK_TIMEOUT * 1000);
    });
  };

  const handleCancel = () => {
    onClose();
    toast({
      title: 'Command cancelled',
      status: 'info',
      duration: 2000,
    });
  };

  const plantOverviewData = (data) => {
    let plantDailyConsumption = 0;
    let plantYearlyConsumption = 0;
    let plantTankLevel = 0;

    for (let item of data) {
      const dailyConsumption = getReadingNumber(item.dailyConsumption) ?? 0;
      const yearlyConsumption = getReadingNumber(item.yearlyConsumption) ?? 0;
      const water_level = getReadingNumber(item.tank_sensor?.water_level) ?? 0;
      plantDailyConsumption += dailyConsumption;
      plantYearlyConsumption += yearlyConsumption;
      plantTankLevel += water_level;
    }

    setWaterTankLevel(plantTankLevel / data.length);
    setPlantDailyCons(plantDailyConsumption.toFixed(2));
    setPlantYearlyCons(plantYearlyConsumption.toFixed(2));
  };

  const fetchOverviewData = async () => {
    try {
      let response;
      if (['companyUser', 'user'].includes(userRole)) {
        response = await axiosInstance.get(
          `${baseUrl}/device-readings/fetchOverviewData`,
          {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          },
        );
      } else if (userRole === 'admin') {
        response = await axiosInstance.get(
          `${baseUrl}/device-readings/fetchOverviewData?companyId=${selectedCompany.current}`,
          {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          },
        );
      }
      if (response) {
        const data = response?.data?.data?.data;
        const now = Date.now();
        const overviewData = (data || []).map((item) => {
          const lastSeenAt = stateLastSeenRef.current[item.productId];
          const status =
            lastSeenAt && now - lastSeenAt <= STATE_STATUS_TIMEOUT_MS
              ? 'online'
              : 'offline';

          return { ...item, status };
        });

        plantOverviewData(overviewData);
        setOverViewData(overviewData);
        updateLicenseData({
          borewellCount: overviewData.length,
        });
      }
    } catch (error) {
      notifyApiError(error, toast, 'Failed to load overview data');
    }
  };

  const fetchCompanies = async () => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/company/list`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      if (response) {
        const data = response?.data?.data?.data;
        setCompanyData(data);
        if (!data || data.length <= 0) {
          toast({
            title: 'No companies found',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
        }
      }
    } catch (error) {
      notifyApiError(error, toast, 'Failed to load company data');
    }
  };

  const fetchPermissibleLimits = async () => {
    try {
      let response;
      if (['companyUser', 'user'].includes(userRole)) {
        response = await axiosInstance.get(
          `${baseUrl}/company/getPermissibleLimits`,
          {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          },
        );
      } else if (userRole === 'admin') {
        response = await axiosInstance.get(
          `${baseUrl}/company/getPermissibleLimits?companyId=${selectedCompany.current}`,
          {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          },
        );
      }
      if (response) {
        const data = response?.data?.data;
        setLimitPerDay(data[0].limitPerDay);
        setlimitPerYear(data[0].limitPerYear);
        updateLicenseData({
          nocNumber: data[0]?.nocDetails?.nocNumber,
          limitPerDay: data[0].limitPerDay,
          limitPerYear: data[0].limitPerYear,
          nocStartDate: data[0]?.nocDetails?.nocExpiry?.startDate,
          nocEndDate: data[0]?.nocDetails?.nocExpiry?.endDate,
          companyLogoUrl: data[0]?.companyLogoUrl,
        });
      }
    } catch (error) {
      notifyApiError(error, toast, 'Failed to load latest readings');
    }
  };

  const checkValidity = (licenseExpiry) => {
    const expiryDate = moment(licenseExpiry.split('T')[0]).toDate();
    const currDate = new Date();
    if (currDate >= expiryDate) {
      return true;
    } else {
      return false;
    }
  };

  const updatePumpStatus = (productId, newStatus) => {
    setOverViewData((prevData) =>
      prevData.map((item) =>
        item.productId === productId
          ? {
              ...item,
              system: {
                ...item.system,
                pump_status: newStatus,
              },
            }
          : item,
      ),
    );
  };

  const updateRemoteStatus = (productId, newStatus) => {
    setOverViewData((prevData) =>
      prevData.map((item) =>
        item.productId === productId
          ? {
              ...item,
              system: {
                ...item.system,
                remote_operations: newStatus,
              },
            }
          : item,
      ),
    );
  };

  const handleRefresh = async () => {
    setLoading(true);

    try {
      await fetchOverviewData();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      toast({
        title: 'Abstraction updated successfully',
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (['companyUser', 'user'].includes(userRole)) {
      fetchOverviewData();
    }
  }, []);

  useEffect(() => {
    if (userRole === 'admin') {
      fetchCompanies();
    }
  }, []);

  useEffect(() => {
    if (['companyUser', 'user'].includes(userRole)) {
      fetchPermissibleLimits();
    }
  }, []);

  // ✅ FIX: Move handler definitions outside useEffect to prevent closures
  // and use useCallback to memoize them
  const onAckHandler = useCallback((msgTopic, message) => {
    if (msgTopic === 'ATBC/D2C') {
      const recPacket = JSON.parse(message.toString());

      if (
        'remote_operations' in recPacket &&
        pendingPIDRef.current === recPacket.pid
      ) {
        if (recPacket['result'] === 'pass') {
          toast({
            title: 'Device acknowledged remote operation command',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          updateRemoteStatus(recPacket.pid, recPacket.remote_operations);
        } else {
          toast({
            title: 'Command failed remote operation',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          toast({
            title: 'Getting back to last state',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
        }
      } else if (
        'pump_control' in recPacket &&
        pendingPIDRef.current === recPacket?.pid
      ) {
        if (recPacket['result'] === 'pass') {
          setProcessing(false);
          toast({
            title: 'Device acknowledged pump control command',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          updatePumpStatus(recPacket.pid, recPacket.pump_control);
        } else {
          setProcessing(false);
          toast({
            title: 'Command failed pump control',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          toast({
            title: 'Getting back to last state',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
        }
      }
      ackReceivedRef.current = true;
      publishingRef.current = false;
      clearInterval(intervalRef.current);
      clearTimeout(timeoutRef.current);
      toast.close('ack-countdown');
    }
  }, []);

  const scheduleStateStatusTimeout = useCallback((productId) => {
    if (!productId) return;

    if (stateStatusTimeoutsRef.current[productId]) {
      clearTimeout(stateStatusTimeoutsRef.current[productId]);
    }

    stateStatusTimeoutsRef.current[productId] = setTimeout(() => {
      setOverViewData((prevData) =>
        prevData.map((item) =>
          item.productId === productId ? { ...item, status: 'offline' } : item,
        ),
      );
      delete stateStatusTimeoutsRef.current[productId];
    }, STATE_STATUS_TIMEOUT_MS);
  }, [STATE_STATUS_TIMEOUT_MS]);

  const onDataHandler = useCallback((msgTopic, message) => {
    const newReading = {};
    const recPacket = JSON.parse(message.toString());

    const flowRate = recPacket.flowmeter_sensor.flowrate;
    const totalizer = recPacket.flowmeter_sensor.totalizer;
    const tankLevel = recPacket.tank_sensor.water_level;
    const tankTemp = recPacket.tank_sensor.water_temperature;
    const borewellLevel = recPacket.borewell_sensor?.water_level;
    const borewellTemp = recPacket.borewell_sensor?.water_temperature;
    const batteryLevel = recPacket.battery_level;
    const datetime = moment(
      recPacket.timestamp,
      'YYYY-MM-DD HH:mm:ss',
    ).toISOString();

    newReading.batterLevel = batteryLevel;
    newReading.pid = recPacket.pid;
    newReading.system = recPacket.system;
    newReading.flowmeter_sensor = {
      flowrate: flowRate,
      totalizer: totalizer,
    };

    newReading.tank_sensor = {
      water_temperature: tankTemp,
      water_level: tankLevel,
    };

    newReading.borewell_sensor = {
      water_temperature: borewellTemp,
      water_level: borewellLevel,
    };

    stateLastSeenRef.current[recPacket.pid] = Date.now();
    scheduleStateStatusTimeout(recPacket.pid);

    setOverViewData((prevData) => {
        // ✅ Guard: Check if data exists
        if (!prevData || prevData.length === 0) {
          console.warn('overViewData is empty, skipping state data update');
          return prevData;
        }

        return prevData.map((item) =>
          item.productId === recPacket.pid
            ? {
                ...item,
                status: 'online',
                updatedAt: datetime,
                system: newReading.system,
                flowmeter_sensor: newReading.flowmeter_sensor,
                tank_sensor: newReading.tank_sensor,
                borewell_sensor: recPacket.borewell_sensor
                  ? newReading.borewell_sensor
                  : item.borewell_sensor,
              }
            : item,
        );
      });
  }, [scheduleStateStatusTimeout]);

  // ✅ SET UP MQTT CONNECTION
  useEffect(() => {
    const client = mqtt.connect(brokerUrl, {
      username: username,
      password: password,
      clean: true,
      reconnectPeriod: 1000,
    });
    clientRef.current = client;

    client.on('connect', () => {
      console.log('Connected to broker');
      client.subscribe(['ATBC/D2C', 'ATBC/STATE'], (err) => {
        if (err) console.error('Subscription failed:', err);
      });
    });

    // ✅ FIX: Set up message handler ONCE, not inside connect callback
    // This prevents multiple handlers from stacking up on reconnection
    const handleMessage = (topic, message) => {
      const t = topic.toString().trim();
      console.log('Message received on topic:', t);

      if (t === 'ATBC/D2C') {
        onAckHandler(t, message);
      } else if (t === 'ATBC/STATE') {
        onDataHandler(t, message);
      }
    };

    messageHandlerRef.current = handleMessage;
    client.on('message', handleMessage);

    return () => {
      // ✅ FIX: Properly remove ALL listeners
      if (messageHandlerRef.current) {
        client.off('message', messageHandlerRef.current);
      }
      client.unsubscribe(['ATBC/D2C', 'ATBC/STATE']);
      clearInterval(intervalRef.current);
      clearTimeout(timeoutRef.current);
      Object.values(stateStatusTimeoutsRef.current).forEach(clearTimeout);
      stateStatusTimeoutsRef.current = {};
      client.end(true);
    };
  }, [onAckHandler, onDataHandler]);

  return (
    <>
      <Modal
        isOpen={isTankModalOpen}
        onClose={() => setisTankModalOpen(false)}
        size="2xl"
        isCentered
      >
        <ModalOverlay />
        <ModalContent
          bg={surfaceBg}
          color={textPrimary}
          borderRadius="xl"
          border="2px solid"
          borderColor={tableBorderColor}
          overflow="hidden"
        >
          <ModalHeader fontSize="xl" fontWeight="bold">
            Tanks Overview
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody pb={6}>
            <Box
              border="1px solid"
              borderColor={tableBorderColor}
              borderRadius="lg"
              overflow="hidden"
            >
            <Table variant="simple">
              <Thead bg={tableHeaderBg}>
                <Tr>
                  <Th
                    textAlign="center"
                    color={accentColor}
                    borderColor={tableBorderColor}
                  >
                    Tanks
                  </Th>
                  <Th
                    textAlign="center"
                    color={accentColor}
                    borderColor={tableBorderColor}
                  >
                    Tank Name
                  </Th>
                  <Th
                    textAlign="center"
                    color={accentColor}
                    borderColor={tableBorderColor}
                  >
                    Tank Capacity
                  </Th>
                  <Th
                    textAlign="center"
                    color={accentColor}
                    borderColor={tableBorderColor}
                  >
                    Connected To
                  </Th>
                </Tr>
              </Thead>

              <Tbody>
                {tankOverViewData?.map((tank) => (
                  <Tr key={tank._id}>
                    <Td textAlign="center" borderColor={tableBorderColor}>
                      <Flex justify="center">
                        <Box position="relative" w="80px" h="80px">
                          <TankLevelIcon width="80px" height="80px" />
                          <Text
                            position="absolute"
                            top="50%"
                            left="50%"
                            transform="translate(-50%, -50%)"
                            fontSize="lg"
                            fontWeight="bold"
                            color={accentStrongColor}
                          >
                            {formatReading(tank.tank_water_level, {
                              decimals: 0,
                              unit: '%',
                            })}
                          </Text>
                        </Box>
                      </Flex>
                    </Td>

                    <Td textAlign="center" borderColor={tableBorderColor}>
                      <Text fontWeight="medium">{tank.name}</Text>
                    </Td>

                    <Td textAlign="center" borderColor={tableBorderColor}>
                      {formatTankCapacity(tank.capacity)}
                    </Td>

                    <Td textAlign="center" borderColor={tableBorderColor}>
                      <Flex direction="column" align="center">
                        {tank.connected_to.map((item, i) => (
                          <Text key={i}>{item}</Text>
                        ))}
                      </Flex>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Box p={{ base: 4, md: 6 }} bg={pageBg} minH="100vh" mt="65px">
        <AlertDialog
          isOpen={isOpen}
          leastDestructiveRef={cancelRef}
          onClose={onClose}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                Confirm Publish
              </AlertDialogHeader>

              <AlertDialogBody>
                Are you certain you want to trigger the command?
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button ref={cancelRef} onClick={handleCancel}>
                  Cancel
                </Button>
                <Button colorScheme="blue" onClick={handleConfirm} ml={3}>
                  Okay
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>

        <Flex
          direction={{ base: 'row', md: 'row', lg: 'row' }}
          align="center"
          wrap="wrap"
          mb={{ base: 2, md: 2, lg: 4 }}
          gap={{ base: 2, md: 2, lg: 4 }}
        >
          <Text
            fontSize={{ base: '20px', md: '24px' }}
            fontWeight="bold"
            color={textPrimary}
          >
            Overview
          </Text>
          <IconButton
            aria-label="Refresh"
            onClick={handleRefresh}
            icon={
              loading ? (
                <Spinner
                  thickness="3px"
                  speed="0.6s"
                  emptyColor="gray.200"
                  color="blue.500"
                  size="sm"
                />
              ) : (
                <RepeatIcon boxSize={5} />
              )
            }
            isRound
            bg={iconButtonBg}
            color={textPrimary}
            _hover={{ bg: iconButtonHoverBg }}
            size="md"
            disabled={loading}
          />
          {userRole === 'admin' && (
            <Select
              placeholder="Select Company..."
              size="md"
              flex="1"
              maxW="210px"
              onChange={(e) => {
                selectedCompany.current = e.target.value;
                setDeviceSearch('');
                fetchOverviewData();
                fetchPermissibleLimits();
              }}
            >
              {companyData.map((item) => (
                <option key={item.productId} value={item._id}>
                  {item.name}
                </option>
              ))}
            </Select>
          )}
          <InputGroup
            flex={{ base: '1 1 100%', md: '0 1 320px' }}
            maxW={{ base: '100%', md: '360px' }}
            ml={{ base: 0, md: 'auto' }}
          >
            <InputLeftElement pointerEvents="none">
              <SearchIcon color={textMuted} />
            </InputLeftElement>
            <Input
              value={deviceSearch}
              onChange={(e) => setDeviceSearch(e.target.value)}
              placeholder="Search Device"
              bg={surfaceBg}
              color={textPrimary}
              borderColor={softBorderColor}
              borderRadius="8px"
              h="44px"
              fontSize="14px"
              _placeholder={{ color: textMuted }}
              _focus={{
                borderColor: accentColor,
                boxShadow: `0 0 0 1px ${accentColor}`,
              }}
            />
          </InputGroup>
        </Flex>

        <Flex
          direction={{ base: 'column', md: 'column', lg: 'row' }}
          gap={6}
          mb={6}
        >
          {overViewData.length > 0 && (
            <Flex
              bg={surfaceBg}
              border="1px solid"
              borderColor={panelBorderColor}
              p={4}
              rounded="2xl"
              shadow={shadowValue}
              direction="column"
              align="center"
              flex={{ base: '1', lg: '1' }}
              w={{ base: '100%', lg: '50%' }}
            >
              <Flex
                gap={4}
                wrap="nowrap"
                w="100%"
                overflowX="auto"
                sx={{
                  '&::-webkit-scrollbar': {
                    height: '8px',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: scrollTrackBg,
                    borderRadius: '10px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: accentColor,
                    borderRadius: '10px',
                  },
                }}
              >
                {filteredOverviewData.length === 0 && (
                  <Flex
                    align="center"
                    justify="center"
                    minH="180px"
                    w="100%"
                    color={textMuted}
                    fontWeight="medium"
                  >
                    No devices found
                  </Flex>
                )}
                {filteredOverviewData.map((device) => {
                  const isPumpOn = device.system.pump_status === 'on';
                  const status = device.status === 'online';
                  const IconComponent =
                    isPumpOn && status
                      ? BorewellIconPumpOn
                      : BorewellIconPumpOff;
                  const shouldBlink = isPumpOn && status;

                  return (
                    <Flex
                      key={device.productId}
                      direction="column"
                      align="center"
                      justify="space-between"
                      bg={subtleSurfaceBg}
                      border="2px solid"
                      borderColor={softBorderColor}
                      rounded="2xl"
                      p={3}
                      w="135px"
                      h="180px"
                      flexShrink={0}
                      marginBottom="15px"
                    >
                      <Box
                        w="100px"
                        h="100px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        mb={2}
                        position="relative"
                      >
                        <IconComponent
                          style={{ width: '90px', height: '90px' }}
                        />
                        {shouldBlink && <Box {...blinkingOverlayProps} />}
                      </Box>

                      <Text
                        fontSize="md"
                        fontWeight="bold"
                        color={textPrimary}
                        textAlign="center"
                        whiteSpace="pre-line"
                        noOfLines={2}
                      >
                        {device.borewellName}
                      </Text>
                    </Flex>
                  );
                })}
              </Flex>
            </Flex>
          )}

          {limitPerDay && (
            <Flex
              bg={surfaceBg}
              border="1px solid"
              borderColor={panelBorderColor}
              p={4}
              rounded="2xl"
              shadow={shadowValue}
              gap={4}
              justify="space-between"
              alignItems="stretch"
              direction={{ base: 'column', md: 'row', lg: 'row' }}
              flex={{ base: '1', lg: '1' }}
              w={{ base: '100%', lg: '50%' }}
            >
              <Box
                flex="1"
                minW="280px"
                p={4}
                rounded="xl"
                border="2px solid"
                borderColor={panelBorderColor}
              >
                <Text
                  fontSize="18px"
                  fontWeight="semibold"
                  color={accentColor}
                  mb={4}
                  textAlign="center"
                >
                  GW Abstraction
                </Text>

                <Box mb={6}>
                  <Flex justify="space-between" mb={1} fontSize="md">
                    <Text fontWeight="bold" textDecoration="underline">
                      Actual Withdrawal
                    </Text>
                    <Text fontWeight="bold" textDecoration="underline">
                      Permitted
                    </Text>
                  </Flex>
                  <Flex justify="space-between" mb={1}>
                    <Text fontSize="md">
                      <Text
                        as="span"
                        fontWeight="semibold"
                        color={accentColor}
                      >
                        {plantDailyCons}m³
                      </Text>
                    </Text>
                    <Text fontSize="md" color="green.500" fontWeight="medium">
                      {limitPerDay}m³/Day
                    </Text>
                  </Flex>
                  <Progress
                    value={Math.max(0, dailyProgressValue)}
                    size="sm"
                    sx={{
                      '& > div': { background: accentColor },
                      bg: progressTrackBg,
                    }}
                    borderRadius="md"
                    w="100%"
                  />
                </Box>

                <Box>
                  <Flex justify="space-between" mb={2}>
                    <Text fontSize="md">
                      <Text
                        as="span"
                        fontWeight="semibold"
                        color={accentColor}
                      >
                        {plantYearlyCons}m³
                      </Text>
                    </Text>
                    <Text fontSize="md" color="green.500" fontWeight="medium">
                      {limitPerYear}m³/Year
                    </Text>
                  </Flex>
                  <Progress
                    value={Math.max(0, yearlyProgressValue)}
                    size="sm"
                    sx={{
                      '& > div': { background: accentColor },
                      bg: progressTrackBg,
                    }}
                    borderRadius="md"
                    w="100%"
                  />
                </Box>
              </Box>

              <Box
                flex="0 0 150px"
                textAlign="center"
                p={4}
                rounded="xl"
                border="2px solid"
                borderColor={panelBorderColor}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                onClick={() => {
                  tanksOverview();
                  tankOverViewData && setisTankModalOpen(true);
                }}
              >
                <Text
                  fontSize="18px"
                  fontWeight="semibold"
                  color={accentColor}
                  mb={4}
                >
                  Overall Tank Capacity
                </Text>

                <Box
                  position="relative"
                  display="inline-block"
                  w="120px"
                  h="120px"
                  mx="auto"
                >
                  <TankLevelIcon style={{ width: '120px', height: '120px' }} />
                  <Text
                    position="absolute"
                    top="55%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                    fontSize="lg"
                    fontWeight="bold"
                    textAlign="center"
                    color={accentStrongColor}
                  >
                    {formatReading(WaterTankLevel, {
                      decimals: 0,
                      unit: '%',
                    })}
                  </Text>
                </Box>
              </Box>
            </Flex>
          )}
        </Flex>

        <Grid
          templateColumns={{
            base: 'repeat(2, 1fr)',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)',
          }}
          gap={6}
          bg={pageBg}
          sx={{
            '@media screen and (min-width: 1024px) and (max-width: 1366px)': {
              gridTemplateColumns: 'repeat(2, 1fr)',
            },
            '@media screen and (min-width: 1800px) and (max-width:2499px)': {
              gridTemplateColumns: 'repeat(4, 1fr)',
            },
            '@media screen and (min-width: 2500px)': {
              gridTemplateColumns: 'repeat(5, 1fr)',
            },
          }}
        >
          {filteredOverviewData.map((item) => {
            const userRole = localStorage.getItem('role');
            const isExpired = checkValidity(item.licenseExpiry);
            const control = item.devicesAccess?.[0]?.control;

            const canControl =
              (userRole !== 'admin' && userRole !== 'user') || control === true;
            const canRemote =
              (userRole !== 'admin' && userRole !== 'user') || control === true;

            const disablePumpBySystem =
              (item.system.operation_mode === 'auto' &&
                item.system.remote_operations === 'off') ||
              item.system.operation_mode === 'manual' ||
              item.system.pump_health === 'fault' ||
              item.status === 'offline';

            const disableRemoteBySystem =
              item.system.operation_mode === 'manual' ||
              item.status === 'offline';

            const disablePump = !canControl || disablePumpBySystem;
            const disableRemote = !canRemote || disableRemoteBySystem;
            const cardOutlineColor =
              item.status === 'online' && item.system.pump_status === 'on'
                ? 'rgba(73, 211, 52, 1)'
                : 'rgba(255, 102, 89, 1)';

            return (
              <Tooltip
                key={item.productId}
                label="License has been expired for this device, please renew to continue..."
                isDisabled={!isExpired}
                hasArrow
              >
                <Box cursor={isExpired ? 'not-allowed' : 'pointer'}>
                  <Box
                    bg={surfaceBg}
                    rounded="2xl"
                    shadow={shadowValue}
                    p={6}
                    border="2px solid"
                    borderColor={cardOutlineColor}
                    opacity={isExpired ? 0.4 : 1}
                    pointerEvents={isExpired ? 'none' : 'auto'}
                  >
                    <Flex justify="space-between" align="flex-start">
                      <VStack align="flex-start" spacing={0}>
                        <Text
                          fontWeight="bold"
                          fontSize="24px"
                          color={textPrimary}
                          lineHeight="1.2"
                        >
                          Borewell - {item.borewellName}
                        </Text>
                      </VStack>

                      <VStack align="center" spacing={0} mt={-4}>
                        {item.status === 'online' ? (
                          <ConnectedIcon
                            style={{ height: '35px', width: '35px' }}
                          />
                        ) : (
                          <DisconnectedIcon
                            style={{ height: '35px', width: '35px' }}
                          />
                        )}

                        <Text
                          fontSize="sm"
                          fontWeight="semibold"
                          color={textMuted}
                        >
                          {item.status}
                        </Text>

                        <Text
                          fontSize="xs"
                          fontWeight="medium"
                          color={accentColor}
                        >
                          {item.system.remote_operations === 'on'
                            ? 'remote'
                            : item.system.operation_mode}
                        </Text>
                      </VStack>
                    </Flex>

                    <Flex align="center" wrap="wrap" gap={8}>
                      <Flex align="center" direction="column" gap={1} p={1}>
                        <Text fontSize="sm" fontWeight="bold" color={textMuted}>
                          {item.productId}
                        </Text>

                        {isProcessing && selectedPID === item.productId ? (
                          <Image
                            src={PumpProcessing}
                            objectFit="fill"
                            rounded="3xl"
                            height="25px"
                            width="35px"
                            shadow="md"
                            bg="orange"
                          />
                        ) : (
                          <Image
                            src={
                              item.system.pump_status === 'on'
                                ? OnIcon
                                : OffIcon
                            }
                            objectFit="fill"
                            rounded="full"
                            height="25px"
                            width="auto"
                            shadow="md"
                            cursor={disablePump ? 'not-allowed' : 'pointer'}
                            opacity={disablePump ? 0.5 : 1}
                            onClick={() => {
                              if (disablePump) return;
                              setSelectedPID(item.productId);
                              handlePumpToggle(
                                item.system.pump_status,
                                item.productId,
                              );
                            }}
                          />
                        )}
                      </Flex>

                      <VStack flexShrink={0} align="center" spacing={0} pt={2}>
                        <Text fontSize="sm" fontWeight="bold" color={textMuted}>
                          Remote Operations
                        </Text>

                        <Box
                          onClick={() => {
                            if (disableRemote) return;
                            setSelectedPID(item.productId);
                            handleRemoteToggle(
                              item.system.remote_operations,
                              item.productId,
                            );
                          }}
                          sx={{
                            cursor: disableRemote ? 'not-allowed' : 'pointer',
                            opacity: disableRemote ? 0.5 : 1,
                          }}
                        >
                          {item.system.remote_operations === 'on' ? (
                            <RemoteButtonOn
                              style={{ height: '40px', width: '55px' }}
                            />
                          ) : (
                            <RemoteButtonOff
                              style={{ height: '40px', width: '55px' }}
                            />
                          )}
                        </Box>
                      </VStack>
                    </Flex>

                    <Grid templateColumns="repeat(3, 1fr)" gap={4} mt={3}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color={textMuted}
                        >
                          Flow Rate
                        </Text>
                        <Text
                          fontWeight="medium"
                          fontSize="xl"
                          color={textPrimary}
                        >
                          {formatReading(item.flowmeter_sensor?.flowrate, {
                            unit: 'm³/hr',
                          })}
                        </Text>
                      </Box>

                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color={textMuted}
                        >
                          Totalizer
                        </Text>
                        <Text
                          fontWeight="medium"
                          fontSize="xl"
                          color={textPrimary}
                        >
                          {formatReading(item.flowmeter_sensor?.totalizer, {
                            unit: 'm³',
                          })}
                        </Text>
                      </Box>

                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color={textMuted}
                        >
                          Abstraction
                        </Text>
                        <Text
                          fontWeight="medium"
                          fontSize="xl"
                          color={textPrimary}
                        >
                          {formatReading(item.dailyConsumption, {
                            unit: 'm³',
                          })}
                        </Text>
                      </Box>
                    </Grid>

                    <Grid
                      templateColumns="1fr auto 1fr"
                      gap={2}
                      mt={5}
                      alignItems="center"
                    >
                      <VStack align="center" spacing={2}>
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color={textMuted}
                        >
                          Automation:{' '}
                          <Text as="span" fontWeight="bold" color={textPrimary}>
                            {item.iotAuto.automation}
                          </Text>
                        </Text>

                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color={textMuted}
                          paddingRight="5px"
                        >
                          Schedule:{' '}
                          <Text as="span" fontWeight="bold" color={textPrimary}>
                            {item.schedule}
                          </Text>
                        </Text>
                      </VStack>

                      <Image
                        src={BorewellImage}
                        boxSize="120px"
                        objectFit="cover"
                        rounded="full"
                        shadow="md"
                      />

                      <VStack align="center" spacing={1} minW="96px">
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color={textMuted}
                          whiteSpace="nowrap"
                        >
                          Borewell Level
                        </Text>
                        <Text fontWeight="bold" color={textPrimary}>
                          {formatReading(item.borewell_sensor?.water_level, {
                            unit: 'm',
                          })}
                        </Text>

                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color={textMuted}
                          mt={1}
                        >
                          Tank Level
                        </Text>
                        <Text fontWeight="bold" color={textPrimary}>
                          {formatReading(item.tank_sensor?.water_level, {
                            unit: '%',
                          })}
                        </Text>

                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color={textMuted}
                        >
                          Pump Health
                        </Text>
                        <Text
                          fontWeight="medium"
                          fontSize="lg"
                          color={
                            item.system.pump_health === 'nofault'
                              ? textPrimary
                              : 'red.500'
                          }
                        >
                          {item.system.pump_health === 'nofault'
                            ? 'OK ✅'
                            : 'Not OK ❌'}
                        </Text>
                      </VStack>
                    </Grid>

                    <Text
                      fontSize="xs"
                      fontWeight="medium"
                      color={textPrimary}
                      mt={4}
                      textAlign="center"
                    >
                      Last Updated - {formatForDateTimeLocal(item.updatedAt)}
                    </Text>
                  </Box>
                </Box>
              </Tooltip>
            );
          })}
        </Grid>

        {overViewData.length > 0 && filteredOverviewData.length === 0 && (
          <Box
            bg={emptyStateBg}
            border="1px solid"
            borderColor={panelBorderColor}
            borderRadius="2xl"
            p={8}
            mt={6}
            textAlign="center"
            color={textMuted}
            fontWeight="medium"
          >
            No devices match your search.
          </Box>
        )}
      </Box>
    </>
  );
}
